import React from 'react';
import { lazyProps } from '@unisporkal/react-lazy-component';
import { LocalizationProvider } from '@unisporkal/localization';
import { ModalProvider } from '@unisporkal/modal';

const Translations = lazyProps(
  (props) => import(`locales/${props.siteName}/${props.locale}`)
);

interface ProvidersProps {
  siteName: string;
  locale: string;
  children: React.ReactNode;
}

const Providers = ({ siteName, locale, children }: ProvidersProps) => (
  <Translations
    siteName={siteName}
    locale={locale}
  >
    {(translations) => (
      <LocalizationProvider
        translations={translations}
        locale={locale}
      >
        <ModalProvider>{children}</ModalProvider>
      </LocalizationProvider>
    )}
  </Translations>
);

export default Providers;
